var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0843 0.999848C10.9147 0.696648 10.6674 0.444157 10.3677 0.268404C10.0681 0.0926522 9.72699 0 9.3796 0C9.03222 0 8.69111 0.0926522 8.39147 0.268404C8.09182 0.444157 7.84447 0.696648 7.67492 0.999848L0.248353 14.2842C0.0822276 14.5814 -0.00335144 14.9168 0.000100438 15.2572C0.00355232 15.5976 0.095915 15.9311 0.268032 16.2248C0.440148 16.5186 0.686042 16.7622 0.981333 16.9315C1.27662 17.1009 1.61106 17.1902 1.95148 17.1905H16.8015C17.142 17.1905 17.4767 17.1014 17.7722 16.9321C18.0677 16.7629 18.3138 16.5193 18.4861 16.2255C18.6584 15.9318 18.7509 15.5981 18.7544 15.2575C18.7579 14.917 18.6724 14.5815 18.5062 14.2842L11.0843 0.999848Z",
    fill: "url(#paint0_linear_444_5217)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5498 12.8936C10.5498 13.2044 10.4263 13.5024 10.2066 13.7222C9.9868 13.942 9.68873 14.0654 9.37793 14.0654C9.06713 14.0654 8.76906 13.942 8.54929 13.7222C8.32952 13.5024 8.20605 13.2044 8.20605 12.8936C8.20605 12.5828 8.32952 12.2847 8.54929 12.0649C8.76906 11.8451 9.06713 11.7217 9.37793 11.7217C9.68873 11.7217 9.9868 11.8451 10.2066 12.0649C10.4263 12.2847 10.5498 12.5828 10.5498 12.8936ZM8.59668 9.37793V5.47168C8.59668 5.26448 8.67899 5.06577 8.8255 4.91925C8.97202 4.77274 9.17073 4.69043 9.37793 4.69043C9.58513 4.69043 9.78384 4.77274 9.93036 4.91925C10.0769 5.06577 10.1592 5.26448 10.1592 5.47168V9.37793C10.1592 9.58513 10.0769 9.78384 9.93036 9.93036C9.78384 10.0769 9.58513 10.1592 9.37793 10.1592C9.17073 10.1592 8.97202 10.0769 8.8255 9.93036C8.67899 9.78384 8.59668 9.58513 8.59668 9.37793Z",
    fill: "url(#paint1_linear_444_5217)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_444_5217",
    x1: 2.92804,
    y1: -2.68609,
    x2: 13.6359,
    y2: 19.5733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8401"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_444_5217",
    x1: 6.25293,
    y1: 4.69043,
    x2: 10.1061,
    y2: 14.9639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.9b3faab8ba73b9743591084db728d59e.svg";
export { ForwardRef as ReactComponent };